import { Plus, Trash2 } from "lucide-react";

const inp = "w-full rounded-lg border border-input bg-white px-2.5 py-1.5 text-sm outline-none focus:ring-2 focus:ring-[#FF7A00]";
const GRID = { 2: "sm:grid-cols-[1fr_2fr_auto]", 3: "sm:grid-cols-[1fr_2fr_.5fr_auto]" };

export const StrList = ({ value = [], onChange, placeholder, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {value.map((v, i) => (
      <div key={i} className="flex gap-2">
        <input data-testid={`${testid}-${i}`} className={inp} value={v} placeholder={placeholder} onChange={(e) => onChange(value.map((x, j) => (j === i ? e.target.value : x)))} />
        <button type="button" data-testid={`${testid}-del-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-[#8A8A8A] hover:text-red-600"><Trash2 size={14} /></button>
      </div>))}
    <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...value, ""])} className="text-xs font-semibold text-[#FF7A00] inline-flex items-center gap-1"><Plus size={12} /> Agregar</button>
  </div>
);

export const PairList = ({ value = [], onChange, cols, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {value.map((row, i) => (
      <div key={i} className={`grid gap-2 ${GRID[cols.length] || GRID[2]}`}>
        {cols.map((ph, c) => <input key={c} data-testid={`${testid}-${i}-${c}`} className={inp} placeholder={ph} value={row[c] || ""} onChange={(e) => onChange(value.map((r, j) => (j === i ? Object.assign([...r], { [c]: e.target.value }) : r)))} />)}
        <button type="button" data-testid={`${testid}-del-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-[#8A8A8A] hover:text-red-600"><Trash2 size={14} /></button>
      </div>))}
    <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...value, cols.map(() => "")])} className="text-xs font-semibold text-[#FF7A00] inline-flex items-center gap-1"><Plus size={12} /> Agregar</button>
  </div>
);
